export default __webpack_public_path__ + "static/media/vg.3a9e3e11.jpg";